import React from "react";
import PackersAndMoversForm from "./pages/Form/Form";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import appBackground from "./assets/images/appBackground.jpg";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Login from "./pages/Login/Login";
import ManagementForm from "./pages/Management/ManagementForm";
import Management from "./pages/Management/Management";
import PrivateRoute from "./layout/PrivateRoute";
import Listing from "./pages/Customer/Listing";
import LocationForm from "./pages/Form/LocationForm";


function App() {
  return (
    <ThemeProvider theme={theme} >
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundAttachment: "fixed",
            backgroundImage: `url(${appBackground})`,
            zIndex: -1,
            opacity: 0.2,
          },
        }}
      >
        <Router>
          <Routes>
            <Route path="/" element={<PackersAndMoversForm />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/login" element={
              <Login />
            } />
            <Route path="/manage" element={
              <PrivateRoute>
                <Management />
              </PrivateRoute>
            } />
            <Route path="/list" element={
              <PrivateRoute>
                <Listing />
              </PrivateRoute>
            } />
          </Routes>
        </Router>
      </Box>
    </ThemeProvider>
  )
}

export default App;
